<template>
<div class="messageDetails">
  <div class="title">标题名称</div>
  <div class="date">
    <span>平台通知</span>
    <span>2019-01-21 15:55</span>
  </div>
  <div class="content">
    文本内容文本内容文本内容文本内容文本内容文本内容文本内容文本内容文本内容文本内容文本内
    容文本内容文本内容文本内容文本内容文本内容文本内容文本内容文本内容文本内容文本内容文本
    内容文本内容文本内容
  </div>
</div>
</template>

<script>
    export default {
      name: "messageDetails",
      data: function () {
        return {

        };
      },
      components: {

      },
      created() {

      },
      mounted() {

      },
      methods: {

      }
    }
</script>

<style  scoped lang="scss" type="text/scss">
  .messageDetails{
    padding: 10px 20px;
    margin-top: 20px;
    box-sizing: border-box;
    background: #fff;
    .title{
      font-size: 34px;
    }
    .date{
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 20px 0;
      box-sizing: border-box;
      border-bottom: 2px dashed #9f9f9f;
    }
    .content{
      padding: 30px 0;
      box-sizing: border-box;
      font-size: 26px;
      color: #6e6e6e;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/message/messageDetails.vue